import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {Table} from "primeng/table";
import {Classdefinition} from "../../model/classdefinition";
import {
  GetFormatListingGQL,
  GetRessourceNumeriqueListingGQL,
  GetRessourceNumeriqueListingQueryVariables
} from "../../../../graphql/generated";
import {ClassdefinitionService} from "../../services/classdefinition.service";
import {map} from "rxjs";
import {extractEdgesAndNodes} from "../../graphql/operators/extract-edges-and-nodes";
import {RessourcesNumeriquesService} from "../../services/ressourcesNumeriques.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
import {Location} from '@angular/common';
import * as FileSaver from 'file-saver';
import {Column} from "../../interfaces/ColumnInterface";
import {ExportColumn} from "../../interfaces/ExportColumnInterface";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageService} from "primeng/api";


@Component({
  selector: 'app-ressources-numeriques-list',
  templateUrl: './ressources-numeriques-list.component.html',
  styleUrls: ['./ressources-numeriques-list.component.scss']
})
export class RessourcesNumeriquesListComponent implements OnInit {

  totalRecords: any = 0
  ressources: any
  dataLoaded: boolean = false
  loading: boolean = true
  checked: boolean = false
  idsToExport: Array<number> = []
  showModalExport: boolean = false
  exportChargement: boolean = false
  form = new FormGroup({
    include_files: new FormControl(),
  });

  @ViewChild('dt') table: Table;
  @ViewChildren('exportCheckBox') exportCheckBoxes: QueryList<ElementRef<HTMLInputElement>>;


  classDef: Classdefinition
  cols!: Column[];

  exportColumns!: ExportColumn[];

  // @ViewChild('filter') filter: ElementRef;
  classDefBaseArticle: Classdefinition;
  formats: any = [];

  constructor(
    private service: GetRessourceNumeriqueListingGQL,
    private classDefinition: ClassdefinitionService,
    private ressourceNumeriqueService: RessourcesNumeriquesService,
    private location: Location,
    private formatService: GetFormatListingGQL,
    private messageService: MessageService,
  ) {
    // this.ouvrages = service.fetch().pipe(
    //         map(result => result.data.getOuvrageListing),
    //         extractEdgesAndNodes(),
    //         tap(departments => this.store.departments$.next(departments)),
    //     );
  }

  ngOnInit() {
    this.classDefinition.load().then(() => {
      this.classDef = this.classDefinition.getByName('RessourceNumerique')
      this.classDefBaseArticle = this.classDefinition.getByName('BaseArticle')
    });

    // const variables: GetRessourceNumeriqueListingQueryVariables = {
    //   first: null,
    //   after: 0
    // }
    //
    // this.service.watch(variables).valueChanges.pipe(
    //   map(result => result.data.getRessourceNumeriqueListing),
    //   extractEdgesAndNodes()
    // ).subscribe({
    //     next: value => {
    //       this.ressources = value
    //       this.dataLoaded = true
    //       this.loading = false
    //       this.totalRecords = this.ressources.length;
    //     },
    //     error: err => {
    //     }
    //   }
    // )

    this.cols = [
      {field: 'ouvrage.BaseArticle.EAN', header: 'EAN'},
      {field: 'ouvrage.BaseArticle.CodeArticle', header: 'Code article'},
      {field: 'ouvrage.BaseArticle.Statut', header: 'Statut'},
      {field: 'ouvrage.BaseArticle.Collection', header: 'Collection'},
      {field: 'ouvrage.BaseArticle.Matieres', header: 'Matière(s)'},
      {field: 'ouvrage.BaseArticle.Classe', header: 'Classe(s)'},
      {field: 'ouvrage.BaseArticle.DateParution', header: 'Date de mise en vente ouvrage'},
      {field: 'ouvrage.CodeProjet', header: 'Code projet'},
      {field: 'titreGrain', header: 'Titre de la ressource', customExportHeader: 'Titre de la ressource'},
      {field: 'categorie', header: 'Catégorie'},
      {field: 'format', header: 'Type'},
      {field: 'filename', header: 'Nom de fichier'},
      {field: 'structure', header: 'Chapitre'},
      {field: 'pageAtterrissage.idPage', header: 'Page'},
      {field: 'destination', header: 'Destinations'},
      {field: 'cible', header: 'Cible (T/P)'},
      {field: 'debutVideo', header: 'Si vidéo Youtube : démarrer la vidéo à x secondes (optionnel)'},
      {field: 'finVideo', header: 'Si vidéo Youtube : finir la vidéo à x secondes (optionnel)'},
      {field: 'Max', header: 'Max'},
      {field: 'cible', header: 'Cible'},
      {field: 'LibTelechargement', header: 'LIB : Téléchargement Oui/Non'},
      {field: 'LibImpression', header: 'LIB : Impression Oui/Non'},
      {field: 'LibModification', header: 'LIB : Modification Oui/non'},
    ];

    this.exportColumns = this.cols.map((col) => ({title: col.header, dataKey: col.field}));
    this.loadFormats()
  }


  private loadFormats() {

    this.formats = []
    this.formatService.watch().valueChanges.pipe(
      map(result => result.data.getFormatListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          for (const entry of value) {
            let format = {key: entry.nom, value: entry.id}
            this.formats.push(format)
          }

          // let instance = this.hotRegisterer.getInstance(this.idTable)
          // for (let i = 0; i < instance.countRows(); i++) {
          //   instance.setCellMeta(
          //     i,
          //     instance.propToCol('child'),
          //     'source',
          //     this.formats,
          //   );
          // }
        },
        error: err => {
        }
      }
    )
  }

  clear(table: Table) {
    table.clear();
    // this.filter.nativeElement.value = '';
  }

  getLabelValues(
    values,
    field
  ) {

    var valuesArrayFormatted: Array<string> = []
    var self = this

    if (values !== null) {
      values.forEach(function (
        value,
        key
      ) {
        if (typeof self.classDefBaseArticle.fdef[field]['optionsLabel'][value] !== 'undefined') {
          var label = self.classDefBaseArticle.fdef[field]['optionsLabel'][value]
          valuesArrayFormatted.push(label)
        }
      });
    }

    return valuesArrayFormatted.join(',')
  }

  downloadFile(idRessource) {
    this.ressourceNumeriqueService.downloadAsset(idRessource).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename')
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error:
        (err) => {
          console.log(err)
        },
    });
  }

  exportExcelBackend() {
    let filters = this.table.filters
    this.ressourceNumeriqueService.downloadXLS(filters).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename')
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error:
        (err) => {
          console.log(err)
        },
    });
  }

  exportCsv() {
    let data = this.table.filteredValue !== null && this.table.filteredValue !== undefined ? this.table.filteredValue : this.ressources
    data = data.filter((ressource) => this.idsToExport.includes(ressource.id));
    this.table.selection = data;
    //this.table.selectionKeys = data.map((ressource) => ressource.id);
    this.table.exportCSV({selectionOnly: true});
  }

  addIdsForExport(
    $event,
    id
  ) {
    if (id === "all") {
      let toCheck = false;
      this.idsToExport = [];
      if ($event.target.checked) {
        toCheck = true;
        this.idsToExport = this.ressources.map((ressource) => ressource.id);
      }
      this.exportCheckBoxes.forEach((checkbox: ElementRef<HTMLInputElement>) => {
        checkbox.nativeElement.checked = toCheck;
      });
    } else {
      if ($event.target.checked) {
        this.idsToExport.push(id);
      } else {
        this.idsToExport = this.idsToExport.filter(item => item !== id);
      }
    }
  }

  exportExcel() {
    import('xlsx').then((xlsx) => {
      let data = this.table.filteredValue !== null && this.table.filteredValue !== undefined ? this.table.filteredValue : this.ressources
      const workBook = xlsx.utils.book_new();
      if (this.idsToExport.length > 0) {
        data = data.filter((ressource) => this.idsToExport.includes(ressource.id));
        const headersLabel = this.cols.map((col) => (col.header));
        const headersPouet = this.cols.map((col) => (col.field));
        xlsx.utils.sheet_add_aoa(workBook, [headersLabel])
        const worksheet = xlsx.utils.sheet_add_json(workBook, data, {
          origin: 'A2',
          header: headersPouet,
          skipHeader: true
        });
        const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']};
        const excelBuffer: any = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
        this.saveAsExcelFile(excelBuffer, 'products');
      }
    });
  }

  saveAsExcelFile(
    buffer: any,
    fileName: string
  ): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  getCompletionMedia(ressource: any): number {
    return (ressource.medias && ressource.medias.length > 0 && ressource.medias[0]?.id !== null) ? 100 : 0;
  }

  getOuvrageLink(ressource: any): any[] | null {
    const ouvrageId = ressource?.ouvrage?.id;
    return ouvrageId ? ['/ressources_numeriques', ouvrageId] : null;
  }

  getDestination(ressource: any) {
    let destinations: Array<string> = []

    if (ressource.OGRNPlay) {
      destinations.push('OGRN Play')
    }
    if (ressource.Max) {
      destinations.push('Max')
    }
    if (ressource.Lib) {
      destinations.push('Lib')
    }

    return destinations.join(', ')
  }

  hasMinilien(ressource: any) {
    if (ressource.pageAtterrissage !== null) {
      if (ressource.pageAtterrissage[0].miniliens !== null) {
        return true
      }
    }

    return false
  }

  loadDatas($event) {

    this.loading = true;

    var filters = $event.filters
    // Chaque filtre peut porter soit une valeur simple (texte, date, dropdown historique),
    // soit un tableau de valeurs (multiSelect) : dans ce dernier cas on combine les valeurs
    // sélectionnées pour une même colonne avec un $or.
    var andParts: Array<any> = []
    for (const key in filters) {
      const rawValue = filters[key].value;
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        continue;
      }
      if (Array.isArray(rawValue) && rawValue.length === 0) {
        continue;
      }

      const extractedValue = this.extraireFiltres(key);
      if (extractedValue === null) {
        continue;
      }
      const field: string = extractedValue;

      if (Array.isArray(rawValue)) {
        if (rawValue.length === 1) {
          andParts.push({[field]: {'$like': '%' + rawValue[0] + '%'}});
        } else {
          andParts.push({
            '$or': rawValue.map(value => ({[field]: {'$like': '%' + value + '%'}}))
          });
        }
      } else {
        andParts.push({[field]: {'$like': '%' + rawValue + '%'}});
      }
    }

    var filterString = andParts.length === 0
      ? null
      : andParts.length === 1
        ? JSON.stringify(andParts[0])
        : JSON.stringify({'$and': andParts})

    const variables: GetRessourceNumeriqueListingQueryVariables = {
      first: $event.rows,
      after: $event.first,
      filter: filterString
    }

    var datas = this.service.watch(variables).valueChanges

    datas.pipe(
      map(result => result)
    ).subscribe({
        next: value => {
          this.totalRecords = value.data.getRessourceNumeriqueListing ? value.data.getRessourceNumeriqueListing.totalCount : 0;
        },
        error: err => {

        }

      }
    )

    datas.pipe(
      map(result => result.data.getRessourceNumeriqueListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          this.ressources = value
          this.dataLoaded = true
          this.loading = false
        },
        error: err => {
          this.loading = false
        }
      }
    )
  }

  private extraireFiltres(chaine) {
    // Découper la chaîne en un tableau en utilisant le point comme séparateur
    const parties = chaine.split('.');

    // Initialiser les variables table et champ
    let table = "";
    let champ = "";

    if (parties.length >= 2) {
      // Récupérer les deux dernières parties
      table = parties[parties.length - 2];
      champ = parties[parties.length - 1];

      return table + '.' + champ
    } else if (parties.length === 1) {
      champ = parties[parties.length - 1];
      // Si la chaîne contient une seule partie, la mettre dans champ
      return champ
    }

    return null;
  }

  onSubmit() {
      this.exportChargement = true
      const include_files = this.form.value.include_files
      const ids = this.idsToExport
     if(this.idsToExport){
       this.ressourceNumeriqueService.makeXlsExport(include_files, ids).subscribe({
          next: (response) => {
            this.exportChargement = false;
            this.showModalExport = false;
            let date = new Date();
            const blob = new Blob([response.body], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = `export_ressources_numériques_${date.toISOString().substring(0, 19)}.zip`;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            if (this.table) {
              this.table.clear();
            }
            this.idsToExport = [];
          },
          error:
            (err) => {
              this.messageService.add({key: 'update', severity: 'error', summary: 'Erreur pendant l\'export',
                detail: err.error.message});
              this.exportChargement = false;
            },
       });
     }
  }
}
